import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FaIconComponent],
    selector: 'app-icon-button',
    styleUrl: './icon-button.component.scss',
    templateUrl: './icon-button.component.html',
})
export class IconButtonComponent {
    public readonly color = input<string>();
    public readonly hoverColor = input<string | undefined>();

    public readonly icon = input.required<IconProp>();
    public readonly iconSize = input<SizeProp>();
}
